module.exports = __webpack_public_path__ + "img/Burger-du-sommet-Max-Quality.eec061f8.jpg";